import cloneDeep from 'lodash.clonedeep'

export const useCloneDeep = cloneDeep
